import _ from "lodash";
import DailyMenuOption from "@/model/dailymenu/DailyMenuOption";
import Tag from "@/model/tennant/Tag";

export default class MenuGroupItem {
  private constructor (
    readonly id:string,
    readonly title: string,
    readonly subGroupList: MenuGroupItem[],
    readonly optionList: DailyMenuOption[],
    readonly tags: Tag[]
  ) {}
  //
  // get selectedOption (): DailyMenuOption | undefined {
  //   return _.find(this.optionList,(option:DailyMenuOption) => {
  //       return option.isSelected
  //   } )
  //
  // }


  get isMenuGroupOffered (): boolean {

    let isOffered = true
    let group = this

    if (group.subGroupList.length > 0) {
      group.subGroupList.forEach((subgroup: MenuGroupItem) => {
        if (subgroup.optionList.length > 0) {
          subgroup.optionList.forEach((option: DailyMenuOption) => {

            if(!option.offer)
              isOffered = false
          })
        }
      })
    }

    if (group.optionList.length > 0) {
      group.optionList.forEach((option: DailyMenuOption) => {
        if(!option.offer)
          isOffered = false
      })
    }

    return isOffered
  }

  static createFromList (responseData: any[]): MenuGroupItem[] {
    return responseData.map( (value:any):MenuGroupItem => MenuGroupItem.createDailyMenuInterface(value))
  }

  static createDailyMenuInterface (responseData: any): MenuGroupItem {
    return new MenuGroupItem(
      responseData.id,
      responseData.title,
      responseData.subGroups ? MenuGroupItem.createFromList(responseData.subGroups):[],
        responseData.slots ? DailyMenuOption.createFromResponse(responseData.slots):[],
        responseData.tags
    )
  }
}
